<template>
  <div>
    <div class="main-page">
      <v-card
        style="border-radius: 12px !important; overflow-x: hidden !important"
        class="mb-6"
      >
        <v-carousel
          cycle
          height="auto"
          hide-delimiter-background
          show-arrows-on-hover
        >
          <v-carousel-item
            v-for="(item, index) in topBanners"
            :key="index"
            style="overflow-x: hidden !important"
          >
            <div @click="goToPage(item.link)">
              <img :src="item.image" alt="" class="banner pointer" />
            </div>
          </v-carousel-item>
        </v-carousel>
      </v-card>

      <v-card
        class="common-card-log lighten-4 mt-6"
        v-if="mostSeller.length > 0"
      >
        <h4 class="mainFont--text ms-2 fs-large">
          <v-icon class="dark-icon me-2">$BoxChecked</v-icon>محصولات پرفروش
        </h4>
        <span v-show="false">{{ reactivity }}</span>

        <Slider :items="mostSeller" />
      </v-card>

      <v-card class="common-card-log lighten-4 mt-6" v-if="pageLoading">
        <div class="text-center">
          <looping-rhombuses-spinner
            :animation-duration="2500"
            :rhombus-size="15"
            color="#a076f9"
            class="mx-auto my-5"
          />
        </div>
      </v-card>
      <v-card
        class="common-card-log lighten-4 mt-6"
        v-if="latestItems.length > 0"
      >
        <h4 class="mainFont--text ms-2 fs-large">
          <v-icon class="dark-icon me-2">$BoxChecked</v-icon>آخرین محصولات
        </h4>
        <span v-show="false">{{ reactivity }}</span>

        <Slider :items="latestItems" />
      </v-card>

      <v-card
        style="border-radius: 12px !important; overflow-x: hidden !important"
        class="mt-6"
      >
        <v-carousel
          cycle
          height="auto"
          hide-delimiter-background
          show-arrows-on-hover
        >
          <v-carousel-item
            v-for="(item, index) in middleBanners"
            :key="index"
            style="overflow-x: hidden !important"
          >
            <div @click="goToPage(item.link)">
              <img :src="item.image" alt="" class="banner pointer" />
            </div>
          </v-carousel-item>
        </v-carousel>
      </v-card>

      <v-card
        class="common-card-log lighten-4 mt-6"
        v-if="childItems.length > 0"
      >
        <h4 class="mainFont--text ms-2 fs-large">
          <v-icon class="dark-icon me-2">mdi-baby-face-outline</v-icon> تازه‌های
          کودک و نوجوان
        </h4>
        <h4
          class="mainFont--text ms-2 fs-large view-more"
          @click="goTochilde()"
        >
          مشاهده بیشتر
        </h4>
        <span v-show="false">{{ reactivity }}</span>

        <Slider :items="childItems" />
      </v-card>

      <v-card
        class="common-card-log lighten-4 mt-6"
        v-if="publishers.length > 0"
      >
        <h4 class="mainFont--text ms-2 fs-large">
          <v-icon class="dark-icon me-2">$BoxChecked</v-icon> انتشارات
        </h4>
        <span v-show="false">{{ reactivity }}</span>

        <!--        <div v-if="pageLoading" class="text-center">-->
        <!--          <looping-rhombuses-spinner-->
        <!--            :animation-duration="2500"-->
        <!--            :rhombus-size="15"-->
        <!--            color="#a076f9"-->
        <!--            class="mx-auto my-10"-->
        <!--          />-->
        <!--        </div>-->

        <div class="products mt-5">
          <PublisherSlider :items="publishers" />
        </div>
      </v-card>

      <v-card
        class="common-card-log lighten-4 mt-6"
        v-if="publishers.length > 0"
      >
        <h4 class="mainFont--text ms-2 fs-large">
          <v-icon class="dark-icon me-2">$BoxChecked</v-icon> مخصوص کنکوری‌ها
        </h4>
        <span v-show="false">{{ reactivity }}</span>
        <SpecialExamSlider :items="specialExam" />
      </v-card>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters, mapMutations } from "vuex";
import { HalfCircleSpinner, LoopingRhombusesSpinner } from "epic-spinners";
import allMajors from "../../assets/images/allMajors.png";
import art from "../../assets/images/art.webp";
import foreignLanguages from "../../assets/images/foreignLanguages.png";
import humanities from "../../assets/images/humanities.webp";
import mathematic from "../../assets/images/mathematic.webp";
import science from "../../assets/images/science.webp";
import vocational from "../../assets/images/vocational.webp";
import Slider from "../../components/OnlineShop/Slider";
import PublisherSlider from "../../components/OnlineShop/PublisherSlider";
import SpecialExamSlider from "../../components/OnlineShop/SpecialExamSlider";
export default {
  components: {
    PublisherSlider,
    SpecialExamSlider,
    Slider,
    LoopingRhombusesSpinner,
    HalfCircleSpinner,
  },
  data() {
    return {
      modelExam: null,
      modelBest: null,
      modelLast: null,
      modelpublish: null,
      shopToken: "",
      cart: [],
      addLoading: [],
      mostSeller: [],
      latestItems: [],
      childItems: [],
      specialProducts: [],
      topBanners: [],
      middleBanners: [],
      publishers: [],
      specialExam: [],
      reactivity: false,
      disableLeft: false,
      disableRight: false,
      pageLoading: false,
      scrollLeftPrev: 0,
      recentlyViewed: [],
      images: {
        art,
        allMajors,
        foreignLanguages,
        humanities,
        mathematic,
        science,
        vocational,
      },
    };
  },
  metaInfo() {
    return {
      title: "کتاب باز",
      meta: [
        {
          name: "description",
          content:
            "کتاب باز با مشورت اساتید و مشاورین به نام کشور؛ در تلاش است بهترین کتب و مناسب‌ترین قیمت‌ها را همراه با تخفیفات باور نکردنی در اختیار شما دانش آموزان عزیز قرار دهد.",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "کتاب باز",
            url: "https://ketabbaaz.com",
            logo: "https://ketabbaaz.com/img/logoname.89d9f7f3.png",
            sameAs: [
              "https://www.instagram.com/ketabbaaz_com", // Social profiles if applicable
              "https://t.me/ketabbaaz_com",
              "https://www.aparat.com/ketabbaaz.com",
            ],
            contactPoint: [
              {
                "@type": "ContactPoint",
                telephone: "+98-21-66120447",
                contactType: "customer service",
                areaServed: "IR",
                availableLanguage: "Persian",
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "کتاب باز",
            image: "https://ketabbaaz.com/img/logoname.89d9f7f3.png",
            url: "https://ketabbaaz.com",
            telephone: "+98-21-66120447",
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "تهران -میدان جمهوری- خ جمهوری- خ گلشن (طاهربهزاد) -خ چنگیزی- نبش کوچه بوذر جمهری - پلاک ۲ (درب سبز رنگ) - واحد ۱",
              addressLocality: "تهران",
              addressRegion: "تهران",
              postalCode: "1318634653",
              addressCountry: "IR",
            },
            // openingHours: "sa-Tu 08:00-18:00", // Adjust based on store's working hours
            // priceRange: "$$", // Relative price range of your products
            geo: {
              "@type": "GeoCoordinates",
              latitude: "35.69555183911308",
              longitude: "51.38434328569981",
            },
            // aggregateRating: {
            //   "@type": "AggregateRating",
            //   ratingValue: "4.5", // Replace with actual rating
            //   reviewCount: "150", // Number of reviews
            // },
          },
        },
      ],
    };
  },

  mounted() {
    this.cart = localStorage.getItem("cart")
      ? JSON.parse(localStorage.getItem("cart"))
      : [];
    this.getData();
  },

  methods: {
    ...mapMutations(["setInCart"]),

    goToPage(item) {
      window.open(item, "_blank");
    },

    goToSpecialExamId(item) {
      let link = "/store/entranceExam=true&entranceExamMajor=" + item;
      this.$router.push(link);
    },
    setInStorage() {
      this.setInCart(this.cart);
      localStorage.setItem("cart", JSON.stringify(this.cart));
    },
    getData() {
      this.pageLoading = true;
      Axios.get(this.baseUrl + "/onlineShop/home", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })

        .then((res) => {
          if (res.status == 200) {
            this.mostSeller = res.data.mostSeller;
            this.latestItems = res.data.latestItems;
            this.childItems = res.data.childItems;
            this.middleBanners = res.data.middleBanners;
            this.publishers = res.data.publishers;
            this.topBanners = res.data.topBanners;
            this.specialExam = res.data.footerMenu;
            if (res.data.hasDiscount) {
              localStorage.setItem("hasDiscount", true);
            } else {
              localStorage.setItem("hasDiscount", false);
            }

            this.ButtonsStatus();
            this.pageLoading = false;
          }
        })
        .catch((err) => {
          this.pageLoading = false;

          this.toast("Error: " + err.response.data, "error");
        });
      this.mostSeller.forEach((x) => {
        this.addLoading.push(false);
      });
    },

    addToCart(item, index) {
      this.addLoading[index] = true;
      this.reactivity = !this.reactivity;
      setTimeout(() => {
        item.amount = 1;
        this.cart.push(item);
        this.setInStorage();
        this.addLoading[index] = false;
        this.reactivity = !this.reactivity;
      }, 500);
    },
    isInCart(item) {
      let index = this.cart.findIndex((x) => x.id == item.id);
      if (index > -1) {
        return true;
      } else return false;
    },
    scroll_left() {
      let box = document.querySelector(".slider");
      let content = document.querySelector(".special-products");
      content.scrollLeft -= Math.ceil(box.getBoundingClientRect().width);
    },
    scroll_right() {
      let box = document.querySelector(".slider");
      let content = document.querySelector(".special-products");
      content.scrollLeft += Math.ceil(box.getBoundingClientRect().width);
    },
    ButtonsStatus() {
      let content = document.querySelector(".special-products");
      if (this.specialProducts.length <= 5) {
        this.disableLeft = true;
      }
      if (Math.abs(content ? content.scrollLeft : 0) < 2) {
        this.disableRight = true;
      } else if (
        Math.ceil(Math.abs(content ? content.scrollLeft : 0)) +
          content.offsetWidth >=
        content.scrollWidth
      ) {
        this.disableLeft = true;
      } else {
        this.disableRight = false;
        this.disableLeft = false;
      }
    },
    goTochilde() {
      const grade = "child";
      if (grade) {
        this.$router
          .push({
            path: "/storeChild",
            query: { grade },
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      } else {
        console.error("Grade is undefined");
      }
    },
  },

  computed: {
    ...mapGetters(["cartItems"]),
    computedProductWidth() {
      if (this.specialProducts && this.specialProducts.length) {
        if (document.querySelector(".slider")) {
          if (window.screen.width < 1280) {
            return "240px";
          } else {
            let box = document.querySelector(".slider");
            return (box.getBoundingClientRect().width - 90) / 5 + "px";
          }
        }
        this.reactivity = !this.reactivity;
      }
    },
  },

  watch: {
    cartItems(val) {
      this.cart = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.view-more {
  color: blue !important; /* Make text blue */
  cursor: pointer; /* Show hand cursor on hover */
  text-align: left; /* Align the text to the left */
}
.slider-items {
  & .v-slide-group__wrapper {
    .v-slide-group__content {
      border-bottom: none !important;
    }
  }
  & [class~="v-slide-group__next"] {
    min-width: 25px !important;
  }
  & [class~="v-slide-group__prev"] {
    min-width: 25px !important;
  }
}
.main-page {
  .products {
    &.special-products {
      overflow-x: auto;
      overflow-y: hidden;
      scroll-behavior: smooth;
      .product-item {
        max-width: none;
      }
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .product-item {
      width: 100%;
      max-width: 250px;
      height: 450px;
      background-color: #fff;
      border-radius: 12px;
      overflow: hidden;
      @media (max-width: 375px) {
        max-width: 200px;
        justify-content: center;
      }
      .product-image {
        position: relative;
        img {
          width: 100%;
          height: 260px;
        }
      }
    }
    // .publish-item {
    //   max-width: 250px;
    //   height: 250px;
    //   @media (max-width: 375px) {
    //     max-width: 200px;
    //     justify-content: center;
    //   }
    //   .product-image {
    //     width: 230px;
    //     height: 230px;
    //     @media (max-width: 375px) {
    //       width: 190px;
    //     }
    //     img {
    //       width: 100%;
    //       height: 100%;
    //       object-fit: contain;
    //     }
    //   }
    // }
  }
}

.section_exam-item {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    text-align: center;
  }
}
.exam-item {
  @media only screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    text-align: center;
  }
}
.exam-image {
  width: 230px;
  height: 200px;
  @media only screen and (max-width: 1366px) {
    width: 180px;
    height: 160px;
  }
  @media only screen and (max-width: 1024px) {
    width: 160px;
    height: 140px;
  }
  @media only screen and (max-width: 768px) {
    width: 200px;
    height: 180px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.text_exam {
  padding: 10px;
  padding-bottom: 0 !important;
  h6 {
    font-size: 15px;
    font-weight: 600;
  }
}
.slider {
  position: relative;
  @media only screen and (min-width: 1279px) {
    margin: 0 46px;
  }
  @media only screen and (max-width: 1279px) {
    margin: 0 10px;
  }
  &-button {
    position: absolute;
    transform: translateY(-30px);
    .v-btn {
      height: 50px !important;
      border-radius: 50px !important;
      background-color: #c6b9e4;
      i {
        color: #a076f9;
      }
    }
  }
  .slider-right-button {
    top: 50%;
    right: -60px;
  }
  .slider-left-button {
    top: 50%;
    left: -60px;
  }
}
.banner {
  overflow-x: hidden !important;
  width: 100% !important;
  height: auto !important;
  background-size: cover !important;
  position: center !important;
  @media screen and (max-width: 600px) {
    height: 150px !important;
    background-size: cover !important;
    position: center !important;
    width: 100% !important;
  }
}
</style>
